// extracted by mini-css-extract-plugin
module.exports = {"companies":"companies-module--companies--3I5Zi","companiesDark":"companies-module--companies--dark--cphzE","companies__item":"companies-module--companies__item--3Xe2A"};